// src/pages/agency/AgencyRoot.jsx
import React from 'react'
import { Box } from '@mui/material'
import { Outlet } from 'react-router-dom'
import { globalStyles } from '../../Utils/Styles'

export default function AgencyRoot() {
  return (
    <Box
      sx={{
        ...globalStyles.wholeHeightMinusToolbar,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Outlet />
    </Box>
  )
}